import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  LabelList,
  ResponsiveContainer
} from "recharts";
import CustomizedAxisTick from "./CustomizedAxisTick";
import CustomTooltip from "./CustomTootltip";

const BarChartComponent = ({ data }) => {
  return (
    <ResponsiveContainer height={130}>
      <BarChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
        <defs>
          {data.map(({ color, colorName }, index) => (
            <linearGradient
              key={`gradient${index}`}
              id={colorName}
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="5%" stopColor={color} stopOpacity={0.5} />
              <stop offset="95%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>

        <CartesianGrid opacity={0.5} vertical={false} />
        <XAxis
          dataKey="name" 
          tickSize={0}
          tickMargin={10}
          tick={<CustomizedAxisTick data={data} />}
          interval={0}
        />

        <YAxis
          style={{ fill: "black", fontSize: "0.625rem", fontWeight: 300 }}
          axisLine={true}
          unit={"%"}
          tickSize={0}
          domain={[0, 100]}
          tickCount={5}
          minTickGap={0}
          tickMargin={10}
          width={40}
        />
        <Tooltip content={<CustomTooltip />} cursor={false} />
        <Bar radius={[50, 50, 0, 0]} barSize={28} dataKey="value">
          <LabelList
            dataKey="value"
            position="top"
            fill="black"
            fontSize="0.625rem"
            fontWeight={700}
            formatter={(value) => `${value}%`} 
          />
          {data.map(({ colorName }, index) => (
            <Cell key={`cell-${index}`} fill={`url(#${colorName})`} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
